
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { useAuth } from '../App';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { axiosInstance } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axiosInstance.post('/auth/forgot-password', { email });
      toast.success(
        "Si ce compte existe, un mail de réinitialisation a été envoyé."
      );
      navigate('/login', { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(
        typeof detail === 'string' ? detail : JSON.stringify(detail)
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: '#d4ebeb' }}
    >
      <form className="bg-white p-6 rounded-lg shadow-md w-full max-w-md space-y-4">
        <h2
          className="text-2xl font-bold text-center"
          style={{ color: '#3f6f70' }}
        >
          Mot de passe oublié
        </h2>

        <Label>Email</Label>

        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="votre.email@example.com"
        />

        <Button
          type="submit"
          disabled={loading}
          className="w-full"
          style={{
            backgroundColor: '#d4ebeb',
            color: '#315c5d',
          }}
        >
          {loading ? 'Envoi...' : 'Envoyer le lien'}
        </Button>
      </form>
    </div>
  );
}